__turbopack_context__.v({
  "menuButton": "tileActionMenu-module-scss-module__yQsnPG__menuButton",
  "menuContainer": "tileActionMenu-module-scss-module__yQsnPG__menuContainer",
  "menuDropdown": "tileActionMenu-module-scss-module__yQsnPG__menuDropdown",
  "menuItem": "tileActionMenu-module-scss-module__yQsnPG__menuItem",
  "menuItemDestructive": "tileActionMenu-module-scss-module__yQsnPG__menuItemDestructive",
});
